import { render, staticRenderFns } from "./ProjectPlatformFacebookMessenger.vue?vue&type=template&id=45754218"
import script from "./ProjectPlatformFacebookMessenger.vue?vue&type=script&lang=ts"
export * from "./ProjectPlatformFacebookMessenger.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports